export const formatGiveawayDate = (
  initDate: string,
  endDate: string,
): string => {
  const months = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];

  const init = new Date(initDate);
  const end = new Date(endDate);

  return `${init.getDate()} ${
    init.getMonth() !== end.getMonth() ? ` ${months[init.getMonth()]}` : ``
  } - ${end.getDate()} ${months[end.getMonth()]}, ${end.getFullYear()}`;
};

export const getGiveawayState = (initDate: string, endDate: string) => {
  const initDateTime = Date.parse(initDate);
  const endDateTime = new Date(endDate).getTime();
  const today = new Date().getTime();
  if (today >= initDateTime && today <= endDateTime) {
    return GiveawayState.CURRENT;
  }
  if (today > endDateTime) {
    return GiveawayState.FINISHED;
  }
  return GiveawayState.WAITING;
};

export const enum GiveawayState {
  CURRENT = 0,
  FINISHED = 1,
  WAITING = 2,
}
